import { AppHeadersService } from "./app-headers.service";
import { AppConfigService } from '../config/app-config.service';

export const AppHeadersServiceProvider = {
    provide: AppHeadersService,
    useFactory: (config: AppConfigService): AppHeadersService => config.headers,
    deps: [AppConfigService]
};
